import { Accordion as MantineAccordion, AccordionProps } from '@mantine/core';

export type IAccordionProps = AccordionProps;

/** @registry Design-layer pass-through over Mantine Accordion; import this instead of @mantine/core Accordion outside src/design. Extend here when Accordion needs house behavior. Compound statics (Accordion.Item, Accordion.Control, Accordion.Panel, ...) are preserved. */
export const Accordion = MantineAccordion;
